export enum FaultUploadType{
  Wifi = 'wifi',
  WifiAndCellular = 'wifiAndCellular'
}